import React, { useContext } from 'react';
import { Update } from '../App';

const ActionProvider = ({ createChatBotMessage, setState, children }) => {
  const {answer}=useContext(Update)
  const handleQuestion = () => {
    const botMessage = createChatBotMessage(`${answer}`);

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          actions: {
            handleQuestion,
          },
        });
      })}
    </div>
  );
};

export default ActionProvider;